export default "__VITE_ASSET__D8_8oS9X__"